<template>
	<div class="FolderIcon2 svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1692083938415" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="41470" :width="size" :height="size">
			<path d="M0 64h404.288L511.36 198.4H1024V960H0V64z m82.432 191.552v89.792h282.88l106.56 134.976H943.04v-90.56h-430.4L404.224 255.552H82.432z" fill="#479afc" p-id="41471"></path>
		</svg>
	</div>
</template>
<script setup name="FolderIcon2">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 24
		}
	})
</script>
<style scoped lang="less">
	.FolderIcon2,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
